import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-sidenav-card',
  templateUrl: './sidenav-card.component.html',
  styleUrls: ['./sidenav-card.component.scss']
})
export class SidenavCardComponent implements OnInit {

  @Input() title;

  constructor() { }

  ngOnInit(): void {
  }

}
